import React from 'react';
import { IonHeader, IonContent, IonIcon, IonToolbar, IonButtons, IonButton } from '@ionic/react';
import { menuOutline } from 'ionicons/icons';

const SmallDrawer = ({ toggleMenu }) => {
  return (
    <>
      <IonHeader className="small-drawer-header">
        <IonToolbar className="small-drawer-toolbar">
          <IonButtons>
            <IonButton button onClick={() => toggleMenu()}>
              <IonIcon mode="ios" icon={menuOutline} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent color="primary"></IonContent>
    </>
  );
};

export default SmallDrawer;
